import Navbar from '@web/Navbar'
import HeroRexLogo from '@web/sections/Hero/HeroRexLogo'
import HeroWave from '@web/sections/Hero/HeroWave'

export const InternalHero = ({
  waveColor,
  backgroundImage = '/website/team-parallax-bg.webp',
}: {
  waveColor?: string
  backgroundImage?: string
}) => {
  return (
    <div className="relative bg-neutral-50">
      {/* HEADER */}
      <header className="absolute inset-x-0 top-0 z-50">
        <Navbar />
      </header>

      {/* Hero Section - Max 50vh */}
      <section
        className="relative h-[50vh] max-h-[600px] min-h-[400px] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-transparent" />

        {/* Logo positioned top-left */}
        <div className="absolute left-6 top-24 z-10 lg:left-12 lg:top-32">
          <HeroRexLogo />
        </div>

        {/* Wave at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <HeroWave color={waveColor} />
        </div>
      </section>
    </div>
  )
}
